import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={{ padding: "80px", textAlign: "center" }}>
      <h1 style={{ fontSize: "48px", fontWeight: "700" }}>404</h1>
      <p style={{ fontSize: "18px", margin: "16px 0" }}>
        Sorry, the page you are looking for does not exist.
      </p>
      <Link
        to="/"
        style={{ color: "#004AAD", fontWeight: "600", textDecoration: "none" }}
      >
        Go back to Home
      </Link>
    </div>
  );
};

export default NotFound;
